var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEiffelTower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.23 122.88",
    style: {
      enableBackground: "new 0 0 61.23 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.88,13.69c-0.27,18.29,2.44,38.64,5.64,59.28h2.57l-2.12,3.12c2.29,7.9,4.67,14.96,7.25,19.99H49v5.79 l12.24,21H48.49c-2.02-21.25-34.44-21.37-35.75,0.01H0l12.29-21.06v-5.74h2.52c3.53-6.73,5.83-13.46,7.35-20.19l-2.01-2.82 l2.52-0.05c3.23-20.04,5.36-39.95,5.74-59.31l-0.37-0.1c-0.08-0.3-0.09-0.6-0.07-0.9l-0.3-0.2c0-0.29,0.01-0.54,0.09-0.81 c-0.17-0.09-0.34-0.2-0.47-0.37c-0.03-0.26-0.01-0.51,0.04-0.76c-0.15-0.25-0.29-0.58-0.4-1l1.04-1.06 c-0.15-0.44-0.29-0.9-0.18-1.34c0.45-0.41,0.93-0.77,1.42-1.09V5.71c0.23-0.22,0.47-0.4,0.72-0.56V0.79L30.59,0l0.64,0.8v4.31 c0.27,0.17,0.54,0.37,0.79,0.6v0.37c0.49,0.32,0.97,0.68,1.42,1.09c0.11,0.44-0.03,0.9-0.18,1.34l1.04,1.06 c-0.11,0.43-0.25,0.75-0.4,1c0.05,0.26,0.07,0.51,0.04,0.76c-0.13,0.17-0.29,0.28-0.47,0.37c0.08,0.27,0.09,0.52,0.09,0.81 l-0.3,0.2c0.02,0.3,0.01,0.6-0.07,0.9L32.88,13.69L32.88,13.69z M23.76,96.31l3.19-14.19h7.25l3.27,14.19H23.76L23.76,96.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiffelTower);
export default __webpack_public_path__ + "static/media/eiffelTower.8c4b4577.svg";
export { ForwardRef as ReactComponent };